import ExternalServicesManager from "./ExternalManageComponents/ExternalServicesManager.js";
import { Divider } from "../mui";
import { HeaderText } from "../components/Text/HeaderText";
import { QueryClient, QueryClientProvider } from "react-query";
import UIWrapper from "../components/UIWrapper";
import { Auth } from "aws-amplify";
const queryClient = new QueryClient();

function ExternalUserAppManager(props) {
  return (
    <>
      <UIWrapper title="User Management" paper>
        <QueryClientProvider client={queryClient}>
          <ExternalServicesManager service={props.service} />
        </QueryClientProvider>
      </UIWrapper>
    </>
  );
}

export default ExternalUserAppManager;
